import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { List } from 'antd';
import { BenefitItems } from 'all-in-one-shared-api';
import { isLocaleEnglish } from 'utils';
import { getUsageItemValue } from 'utils/benefits/outpatient/usage';
import { USAGE_LABEL_COLORS } from '../constants/UsageLabelColor';

const ColorLabel = styled.div<{ bgColor: string }>`
  width: 15px;
  height: 15px;
  background-color: ${({ bgColor }) => bgColor};
`;

const MaxValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export interface UsageItemProp {
  item: BenefitItems;
  isGroupItem: boolean;
  index: number;
}

function UsageItem({ item, isGroupItem, index }: UsageItemProp) {
  const { name, nameCn, limitUsed, paidAmount } = item;

  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);

  const GroupItem = (): JSX.Element => {
    return (
      <>
        <List.Item.Meta
          avatar={isGroupItem && <ColorLabel bgColor={USAGE_LABEL_COLORS[index]} />}
          title={isEnglish ? name : nameCn}
          description={`HKD ${paidAmount} ${t('common.used')}`}
        />
        <div data-testid="number-of-visit">{`${parseInt(limitUsed ?? '')} ${t('benefits.visitsUsed')}`}</div>
      </>
    );
  };

  const NonGroupItem = (): JSX.Element => {
    const { maxDescription, maxDescriptionCn, maxValue, valueUsed } = getUsageItemValue(item);

    return (
      <>
        <List.Item.Meta title={isEnglish ? name : nameCn} description={valueUsed} />
        <MaxValueContainer>
          <div>{isEnglish ? maxDescription : maxDescriptionCn}</div>
          <div data-testid="mock-maxValue">{maxValue}</div>
        </MaxValueContainer>
      </>
    );
  };

  return <List.Item key={item.id}>{isGroupItem ? <GroupItem /> : <NonGroupItem />}</List.Item>;
}

export default UsageItem;
